// Loads Authorize.net Accept.js on demand (staff "Take payment"). Card numbers
// go straight from the browser to Authorize.net; we only ever see the token.
import { useEffect, useState } from "react";

export function useAcceptJsLoader(mode: string | undefined, enabled: boolean) {
  const w = window as any;
  const [ready, setReady] = useState<boolean>(() => !!w.Accept);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!enabled || !mode) return;
    if (w.Accept) { setReady(true); return; }
    const src = mode === "production" ? "https://js.authorize.net/v1/Accept.js" : "https://jstest.authorize.net/v1/Accept.js";
    const existing = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement | null;
    const el = existing || document.createElement("script");
    const onLoad = () => setReady(!!w.Accept);
    const onErr = () => setFailed(true);
    el.addEventListener("load", onLoad); el.addEventListener("error", onErr);
    if (!existing) { el.src = src; el.async = true; el.setAttribute("charset", "utf-8"); document.body.appendChild(el); }
    else if (w.Accept) setReady(true);
    return () => { el.removeEventListener("load", onLoad); el.removeEventListener("error", onErr); };
  }, [mode, enabled]);
  return { ready, failed };
}

export function tokenizeCard(
  auth: { clientKey: string; apiLoginID: string },
  card: { cardNumber: string; month: string; year: string; cardCode: string; zip?: string },
): Promise<{ dataDescriptor: string; dataValue: string }> {
  const w = window as any;
  return new Promise((resolve, reject) => {
    if (!w.Accept) { reject(new Error("The secure card form has not finished loading.")); return; }
    w.Accept.dispatchData({ authData: auth, cardData: card }, (resp: any) => {
      if (resp?.messages?.resultCode === "Error") {
        reject(new Error((resp.messages.message || []).map((m: any) => m.text).join(" ") || "Card was declined by the card form."));
      } else resolve(resp.opaqueData);
    });
  });
}
